<template>
  <div class="newPost">
    <div class="newPost__header">
      Создание нового курса
      <CloseSvg class="closeSvg closeSvg--white" @click="toggleCourseNew" />
    </div>
    <div class="newPost__content">
      <CustomInput
        class="newPost__item newPost__item--full"
        :label="'Заголовок'"
        :placeholder="'Заголовок'"
        :value="title"
        @inputs="value => (title = value)"
      />

      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Старая цена'"
        :placeholder="'Старая цена'"
        :value="priceStart"
        @inputs="value => (priceStart = value)"
      />
      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Новая цена'"
        :placeholder="'Новая цена'"
        :value="priceFull"
        @inputs="value => (priceFull = value)"
      />

      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Просмотры'"
        :placeholder="'Просмотры'"
        :value="views"
        @inputs="value => (views = value)"
      />
      <CustomInput
        class="newPost__item newPost__item--half"
        :label="'Дата публикации'"
        :value="date"
        :type="'date'"
        @inputs="value => (date = value)"
      />

      <CustomTextarea
        class="newPost__item"
        :label="'Описание'"
        :placeholder="'Описание'"
        :value="description"
        @inputs="value => (description = value)"
      />
      <CustomTextarea
        class="newPost__item"
        :label="'Что вас ожидает'"
        :placeholder="'Что вас ожидает'"
        :value="expectation"
        @inputs="value => (expectation = value)"
      />
      <CustomTextarea
        class="newPost__item"
        :label="'Программа'"
        :placeholder="'Программа'"
        :value="program"
        @inputs="value => (program = value)"
      />
      <CustomTextarea
        class="newPost__item"
        :label="'Что вы получаете'"
        :placeholder="'Что вы получаете'"
        :value="outcome"
        @inputs="value => (outcome = value)"
      />

      <CustomSelectbox
        class="profile__item profile__item--half"
        :label="'Категория'"
        :key-name="'name'"
        :name="'category'"
        :options="[
          { id: 'new', name: 'Новичкам' },
          { id: 'combo', name: 'Комбо' },
          { id: 'experienced', name: 'Опытным' },
          { id: 'masterclass', name: 'Мастеркласс' },
          { id: 'woman', name: 'Женский' }
        ]"
        @inputs="value => (category = value.id)"
      />
      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Никнейм (1 слово)'"
        :placeholder="'Никнейм'"
        :value="nickname"
        @inputs="value => (nickname = value)"
      />

      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Месяцев (период)'"
        :placeholder="'0'"
        :value="durationMonths"
        @inputs="value => (durationMonths = value)"
      />
      <CustomInput
        class="profile__item newPost__item--half"
        :label="'Дней (период)'"
        :placeholder="'0'"
        :value="durationDays"
        @inputs="value => (durationDays = value)"
      />

      <CustomSelectbox
        class="profile__item profile__item--full"
        :label="'Принадлежность'"
        :key-name="'name'"
        :name="'affiliation'"
        :options="[
          { id: 'inner', name: 'Внутреннее обучение' },
          { id: 'kontora_tseh', name: 'Контора/Цех' },
          { id: 'manufactura', name: 'Мануфактура' }
        ]"
        @inputs="value => (affiliation = value.id)"
      />

      <img v-if="selectedImgSrc != ''" class="newPost__image" :src="selectedImgSrc" />

      <div class="newPost__footer">
        <div class="newPost__load">
          <AttachmentSvg class="newPost__icon" />
          <div v-if="selectedImgSrc == ''">Загрузить обложкку</div>
          <div v-else>Изменить обложкку</div>
          <input class="newPost__files" type="file" @change="selectImage" />
        </div>

        <Button :disabled="title == ''" @click="create" />
      </div>
    </div>
  </div>
</template>

<script setup>
// Svg
import CloseSvg from '@/components/svg/CloseSvg'
import AttachmentSvg from '@/components/svg/AttachmentSvg'

// Components
import CustomInput from '@/components/CustomInput'
import CustomSelectbox from '@/components/CustomSelectbox'
import CustomTextarea from '@/components/CustomTextarea'
import Button from '@/components/Button'

// Helpers
import useAlert from '@/mixins/useAlert'
import useCourse from '@/mixins/useCourse'

import { ref } from 'vue'

const title = ref('')
const priceStart = ref('')
const priceFull = ref('')
const views = ref('')
const date = ref('')
const description = ref('')
const expectation = ref('')
const program = ref('')
const outcome = ref('')
const category = ref('')
const nickname = ref('')
const durationMonths = ref('')
const durationDays = ref('')
const affiliation = ref('')
const selectedImgSrc = ref('')
const imgFile = ref('')
const { alertTitle, alertTitleSuccess, alertSubtitle, alertSubtitleSuccess, toggleAlert, task } = useAlert()
const {
  courseTitle,
  coursePriceStart,
  coursePriceFull,
  courseViews,
  courseDate,
  courseDescription,
  courseExpectation,
  courseProgram,
  courseOutcome,
  courseCategory,
  courseNickname,
  courseDurationMonths,
  courseDurationDays,
  courseAffiliation,
  courseImgFile,
  toggleCourseNew,
  createCourse
} = useCourse()

const selectImage = e => {
  imgFile.value = e.target.files
  selectedImgSrc.value = URL.createObjectURL(e.target.files[0])
}

const create = () => {
  courseTitle.value = title.value
  coursePriceStart.value = priceStart.value
  coursePriceFull.value = priceFull.value
  courseViews.value = views.value
  courseDate.value = date.value
  courseDescription.value = description.value
  courseExpectation.value = expectation.value
  courseProgram.value = program.value
  courseOutcome.value = outcome.value
  courseCategory.value = category.value
  courseNickname.value = nickname.value
  courseDurationMonths.value = durationMonths.value
  courseDurationDays.value = durationDays.value
  courseAffiliation.value = affiliation.value
  courseImgFile.value = imgFile.value

  alertTitle.value = 'Создать новый курс?'
  alertTitleSuccess.value = 'Курс создан'
  alertSubtitle.value = 'Будет создан новый курс в разделе "Обучение"'
  alertSubtitleSuccess.value = 'Курс создан'
  task.value = createCourse
  toggleAlert()
}
</script>

<style scoped>
.newPost {
  background: #343c42;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  margin-bottom: 30px;
}
.newPost__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #5d6368;
  letter-spacing: 0.02em;
}
.newPost__content {
  padding: 16px 40px;
  display: flex;
  flex-wrap: wrap;
}
.newPost__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  margin-top: 16px;
}
.newPost__load {
  position: relative;
  color: #71777b;
  display: flex;
  align-items: center;
}
.newPost__files {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  font-size: 0;
  text-indent: -100px px;
  cursor: pointer;
}
.newPost__icon {
  margin-right: 8px;
}
.newPost__item {
  margin-bottom: 24px;
}
.newPost__item--full {
  width: 100%;
}
.newPost__item--half {
  width: calc(50% - 8px);
}
.newPost__image {
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .newPost__content {
    padding: 16px;
  }
  .newPost__footer {
    display: block;
    margin-top: 0;
  }
  .newPost__image {
    margin-bottom: 16px;
  }
  .newPost__load {
    margin-bottom: 16px;
  }
}
</style>
